import React from 'react';
import {Text, Heading} from '@albert-io/atomic';
import PropTypes from 'prop-types';
import moment from 'moment';

const Stat = ({text, count}) => {
  return (
    <div className='author-dashboard-header-stats__stat'>
      <div className='author-dashboard-header-stats__count'>
        <Heading size='xl'>{count}</Heading>
      </div>
      <div style={{textAlign: 'center'}}>
        <Text size='m' emphasis='lowest'>
          {text}
        </Text>
      </div>
    </div>
  );
};

function formatJoinedDate(date) {
  return moment(date).format('MMMM YYYY');
}

const AuthorDashboardHeaderStats = ({count, data}) => {
  return (
    <div className='author-dashboard-header-stats__container'>
      <Text size='xl' emphasis='lowest'>
        Questions you&apos;ve published:
      </Text>
      <div className='author-dashboard-header-stats__text-container u-mar-t_3'>
        <Stat
          count={count.allTime}
          text={`Since joining in ${formatJoinedDate(data.getInsertedAt())}`}
        />
        <Stat count={count.thisYear} text={`in ${moment().year()}`} />
        <Stat count={count.thisMonth} text='this month' />
      </div>
    </div>
  );
};

AuthorDashboardHeaderStats.propTypes = {
  count: PropTypes.shape({
    allTime: PropTypes.number,
    thisYear: PropTypes.number,
    thisMonth: PropTypes.number
  }),
  data: PropTypes.object
};

export default AuthorDashboardHeaderStats;
